import { Box } from '@mui/material';
import { FeedPost } from '../FeedPost/FeedPost';
import { feedSx } from './Feed.style';
import { DEFAULT_POST } from '../../constants/post';
import { useChallengeStartTime } from '../../hooks/useChallengeStartTime/useChallengeStartTime';

export const Feed = ({ feed }) => {
  const { challengeStartTime } = useChallengeStartTime();

  return (
    <Box sx={feedSx}>
      {feed?.map((p, i) => (
        <FeedPost
          key={i}
          postId={p.id}
          userId={p.userId}
          name={p.name}
          content={p.content}
          created={p.created}
          img={p.img}
        />
      ))}

      <FeedPost
        postId={DEFAULT_POST.defaultId}
        userId={DEFAULT_POST.defaultId}
        name={DEFAULT_POST.name}
        content={DEFAULT_POST.content}
        created={challengeStartTime}
      />
    </Box>
  );
};
